import * as React from 'react';
import { styled } from '@glitz/react';

type PropType = {
  infoBox: { [item: string]: string };
};

export const InfoBox = (props: PropType) => {
  return props.infoBox ? (
    <Container>
      {Object.entries(props.infoBox).map(([key, value]) => (
        <React.Fragment key={key}>
          <Header>{key}</Header>
          <Info>{value}</Info>
        </React.Fragment>
      ))}
    </Container>
  ) : null;
};

const Container = styled.div({
  padding: { x: t => t.sharedSpacing.m, y: t => t.sharedSpacing.m },
  backgroundColor: t => t.productPageInfo?.color,
});

const Header = styled.h3({
  fontSize: t => t.sharedFontSize.l,
  fontWeight: 450,
  lineHeight: 1.3,
});

const Info = styled.div({
  fontSize: t => t.sharedFontSize.xs,
  fontWeight: 400,
});
